import { render, staticRenderFns } from "./PaymentMappingsTab.vue?vue&type=template&id=18b8c87e&scoped=true&"
import script from "./PaymentMappingsTab.vue?vue&type=script&lang=js&"
export * from "./PaymentMappingsTab.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMappingsTab.vue?vue&type=style&index=0&id=18b8c87e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b8c87e",
  null
  
)

export default component.exports